import React, { createContext, useEffect, useMemo, useState } from "react";
import Cookies from "js-cookie";

const initialValue = {};

export const AccessTokenContext = createContext(initialValue);

export default function AccessTokenProvider({ children }) {
  const [accessToken, setAccessToken] = useState(null);
  const [identityIdToken, setIdentityIdToken] = useState(null)

  useEffect(() => {
    const accessTokenFromCookie = Cookies.get("cognito-access-token");
    const identityIdTokenFromCookie = Cookies.get("cognito-identity-id-token");

    if (accessTokenFromCookie) {
      setAccessToken(accessTokenFromCookie);
    }

    if (identityIdTokenFromCookie) {
      setIdentityIdToken(identityIdTokenFromCookie);
    }
  }, []);

  const value = useMemo(() => ({ accessToken, identityIdToken }), [accessToken, identityIdToken]);

  return (
    <AccessTokenContext.Provider value={value}>
      {children}
    </AccessTokenContext.Provider>
  );
}
